// Module
var code = "<skip-link></skip-link><navigation [hidden]=\"$root.noNavigation\"></navigation><main ng-style=\"{ 'background-color': backgroundColor }\" ng-class=\"{ 'new-layout': useNewLayout }\"><demo-banner></demo-banner><div ui-view></div></main><snackbar></snackbar>";
// Exports
module.exports = code;